export const CalculatorField = {
  HomeValue: "homeValueEstimate",
  OutstandingValue: "remainingMortgageEstimate",
  DepositValue: "depositValue",
  DepositNeeded: "depositNeeded",
  MonthlyRepayment: "monthlyMortgagePayment",
  HelpPercentage: "fintreeHelpPercentage",
  UpgradeBudget: "upgradeBudget",
  YearsLeftOnMortgage: "yearsLeftOnMortgage",
} as const;

export type CalculatorFieldType = (typeof CalculatorField)[keyof typeof CalculatorField];

interface BaseForm {
  emailAddress: string;
}

export interface HomeownershipAcceleratorNumbers {
  [CalculatorField.HomeValue]: number;
  [CalculatorField.DepositValue]: number;
  [CalculatorField.DepositNeeded]: number;
}

export interface CalculatorTypes {
  [CalculatorField.HomeValue]: number;
  [CalculatorField.UpgradeBudget]: number;
}

export interface HomeownerAssistantNumbers {
  [CalculatorField.HomeValue]: number;
  [CalculatorField.DepositValue]: number;
  [CalculatorField.MonthlyRepayment]: number;
  [CalculatorField.HelpPercentage]: number;
  [CalculatorField.YearsLeftOnMortgage]: number;
}

export type CalculatorForm<T> = BaseForm & { context: T };

export type HomeownershipAcceleratorForm = CalculatorForm<HomeownershipAcceleratorNumbers>;
export type UpgradeAcceleratorForm = CalculatorForm<CalculatorTypes>;
export type HomeownerAssistantForm = CalculatorForm<HomeownerAssistantNumbers>;
